import { render, staticRenderFns } from "./AddMemberPopup.vue?vue&type=template&id=4700cd26"
import script from "./AddMemberPopup.vue?vue&type=script&lang=ts"
export * from "./AddMemberPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports